module.exports = __webpack_public_path__ + "img/terminal-hse-guideline-2.5c822496.png";